<template lang='pug'>
  i.svg-icon.svg-icon-gender
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M78.359,11.656H65.906c-1.047,0-1.897,0.844-1.897,1.891 c0,0.503,0.198,0.983,0.553,1.341l2.671,2.663L54.515,30.259c-10.616-6.666-24.625-3.461-31.288,7.155 c-6.664,10.616-3.46,24.625,7.156,31.292c2.155,1.353,4.522,2.333,7.002,2.9v4.349h-5.674c-1.042,0.004-1.889,0.851-1.891,1.894 v6.307c0.002,1.042,0.849,1.887,1.891,1.89h5.674v4.413c0.004,1.042,0.849,1.885,1.891,1.887h6.307 c1.043-0.002,1.888-0.849,1.891-1.89v-4.413h5.673c1.044,0,1.89-0.849,1.892-1.893v-6.303c-0.002-1.045-0.848-1.892-1.892-1.892 h-5.676v-4.349c12.223-2.787,19.875-14.951,17.091-27.175c-0.567-2.495-1.554-4.874-2.913-7.038l12.708-12.717l2.664,2.67 c0.739,0.74,1.937,0.74,2.674,0c0.359-0.355,0.559-0.84,0.556-1.343V13.546C80.249,12.505,79.401,11.658,78.359,11.656z M42.428,62.085c-6.963,0-12.608-5.644-12.608-12.607c0-6.962,5.645-12.607,12.608-12.607c6.963,0,12.608,5.646,12.608,12.607l0,0 C55.026,56.439,49.387,62.078,42.428,62.085z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>